<script lang="ts">
    import {z, ZodError} from "zod";
    import {_} from 'svelte-i18n';
    import InputNumber from "../../shared/InputNumber.svelte";

    export let label: string = '';
    export let annotation: string = $_('min:sec');
    export let value: number = 0;
    export let minutesStep: number = 1;
    export let secondsStep: number = 15;
    export let max: number = 60;
    export let update: () => void;
    export let validator: (data: unknown) => { success: true; data: number; } | { success: false; error: ZodError; }

    let minutes: number = 0;
    let seconds: number = 0;
    let minutesString: string = '';
    let secondsString: string = '';

    let error: string = '';

    function validate(value: string, min: number, max: number) {
        return z.coerce.number().min(min).max(max).safeParse(value);
    }

    $: {
        minutes = Math.floor(value);
        seconds = Math.round((value - minutes) * 60);
    }

    $: {
        minutesString = minutes.toString();
        secondsString = seconds.toString().padStart(2, '0');
    }

</script>

<div class="settings-group" class:error={error!==''}>
    <div class="settings-label">{label}</div>
    <div>
        <div style="display:flex; flex-direction: row; align-items: center; column-gap: 4px;">
            <InputNumber
                value={minutesString}
                step={minutesStep.toString()}
                min="0"
                max={max.toString()}
                width="100%"
                on:change={
                        (event) => {
                            const newValue = event.target?.value;
                            let result = validate(newValue, 0, 60);
                            if (result.success) {
                                error = '';
                                minutes = result.data;
                                value = minutes + seconds / 60;
                                if (validator(value).success) {
                                    update();
                                }
                            } else {
                                error = result.error.issues[0].message;
                            }
                        }
               }
            />
            :
            <InputNumber
                value={secondsString}
                step={secondsStep.toString()}
                min="-15"
                max="60"
                width="100%"
                on:input={
                    (event) => {
                        const newValue = event.target?.value;
                        let result = validate(newValue, -15, 60);
                        if (result.success) {
                            error = '';
                            seconds = result.data;
                            if (seconds > 0 && minutes == max) {
                                seconds = 0;
                                event.target.value = '00';
                            } else if (seconds == 60) {
                                seconds = 0;
                                minutes++;
                            } else if (seconds < 0) {
                                if (minutes > 0) {
                                    seconds = 60 + seconds;
                                    minutes--;
                                } else {
                                    seconds = 0;
                                    event.target.value = '00';
                                }
                            }
                            console.log('seconds', seconds);
                            value = minutes + seconds / 60;
                            if (validator(value).success) {
                                update();
                            }
                        } else {
                            error = result.error.issues[0].message;
                        }
                    }
                }
            />
            <div>{annotation}</div>
        </div>
        {#if error!==''}
            <div class="error-message">{error}</div>
        {/if}
    </div>
</div>

<style>
    .settings-group {
        display: flex;
        align-items: center;
        column-gap: 10px;
        justify-content: flex-start;
        min-height: 33px;
        font-size: 14px;
        border-radius: 6px;
        margin-bottom: 3px;
        padding: 3px 6px;
    }
    .settings-label {
        flex: 0.1 1 100px;
        /*min-width: 120px;*/
        /*white-space: nowrap;*/
    }
    .settings-value {
        flex: 0 0 60px;
        box-sizing: border-box;
        width: 100%;
        /*padding: 3px 6px;*/
        margin: 0 3px;
        background-color: #ffffff;
        border: 0;
        /*border-radius: 4px;*/
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        border-radius: var(--input-small-border-radius);
        color: var(--input-small-color);
    }
    .error {
        /*background-color: var(--automapa-red);*/
        border: 2px solid var(--automapa-red);
    }
    .error-message {
        margin-top: 3px;
    }
</style>
